import { Routes, Route } from 'react-router-dom';
import { Navigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import TeamEntryManagementContextView from './TeamEntryManagementContextView';
import TeamEntryManagementById from './TeamEntryManagementById';
import TeamEntryManagementByIdNonHQ from './TeamEntryManagementByIdNonHQ';
import TeamEntryManagementByIdOrgUnitSelection from './teamEntryManagementByIdOrgUnitSelection/TeamEntryManagementByIdOrgUnitSelection';
import TeamEntryManagementByIdHQOrgUnitSelection from './teamEntryManagementByIdHQOrgUnitSelection/TeamEntryManagementByIdHQOrgUnitSelection';

import OmeMeetContextProvider from '../../state/omeMeet/OmeMeetContextProvider';
import OmeMeetEntryContextProvider from '../../state/omeMeetEntry/OmeMeetEntryContextProvider';
import OmeMeetEntryInfoContextProvider from '../../state/omeMeetEntryInfo/OmeMeetEntryInfoContextProvider';
import OrgUnitOmeMeetEntryContextProvider from '../../state/orgUnitOmeMeetEntry/OrgUnitOmeMeetEntryContextProvider';
import OmeMeetOrgUnitEntryContextProvider from '../../state/omeMeetOrgUnitEntry/OmeMeetOrgUnitEntryContextProvider';
import OmeMeetOrgUnitEntryInfoContextProvider from '../../state/omeMeetOrgUnitEntryInfo/OmeMeetOrgUnitEntryInfoContextProvider';
import OmeMeetTeamEntryContextProvider from '../../state/omeMeetTeamEntry/OmeMeetTeamEntryContextProvider';
import OmeMeetTeamEntryFiltersContextProvider from '../../state/omeMeetTeamEntry/OmeMeetTeamEntryFiltersContextProvider';
import MeetCompetitionSummaryContextProvider from '../../state/meetCompetitionSummary/MeetCompetitionSummaryContextProvider';
import OmeMeetAthleteEntryContextProvider from '../../state/omeMeetAthleteEntry/OmeMeetAthleteEntryContextProvider';
import OmeMeetAthleteEntryFiltersContextProvider from '../../state/omeMeetAthleteEntry/OmeMeetAthleteEntryFiltersContextProvider';
import OmeMeetOrgUnitAthleteEntryIndividualRosterEntryContextProvider from '../../state/omeMeetOrgUnitAthleteEntryIndividualRosterEntry/OmeMeetOrgUnitAthleteEntryIndividualRosterEntryContextProvider';

import MeetContextProvider from '@usas/ui-web/state/meet/MeetContextProvider';
import MeetFiltersContextProvider from '@usas/ui-web/state/meet/MeetFiltersContextProvider';
import PersonOrgRoleContextProvider from '@usas/ui-web/state/personOrgRole/PersonOrgRoleContextProvider';
import SearchMeetContextProvider from '@usas/ui-web/state/searchMeet/SearchMeetContextProvider';
import MeetStaffContextProvider from '@usas/ui-web/state/meet/meetStaff/MeetStaffContextProvider';

import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';
import SecuredRouteElement from '@usas/ui-web/components/security/SecuredRouteElement';

import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';

const TeamEntryManagementRoutes = () => {
  const { navRoutes, isReadyToRoute } = useNavRoutes();

  if (isReadyToRoute !== true) {
    return <LoadingModal />;
  }

  return (
    <TeamEntryManagementContextView>
      <Routes>
        <Route path={navRoutes['TEAM_ENTRY_MANAGEMENT_BY_ID']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['TEAM_ENTRY_MANAGEMENT_BY_ID']}
              editElement={<TeamEntryManagementById />}
              readOnlyElement={<TeamEntryManagementByIdNonHQ />} />
          }
        />
        <Route path={navRoutes['TEAM_ENTRY_MANAGEMENT_BY_ID_SELECTION']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['TEAM_ENTRY_MANAGEMENT_BY_ID_SELECTION']}
              editElement={<TeamEntryManagementByIdOrgUnitSelection />} />
          }
        />
        <Route path={navRoutes['TEAM_ENTRY_MANAGEMENT_BY_ID_HQ_SELECTION']?.path}
          element={
            <SecuredRouteElement
              navRoute={navRoutes['TEAM_ENTRY_MANAGEMENT_BY_ID_HQ_SELECTION']}
              editElement={<TeamEntryManagementByIdHQOrgUnitSelection />} />
          }
        />
        <Route path={'/'} element={<Navigate to={navRoutes['TEAM_ENTRY_MANAGEMENT_BY_ID']?.route} replace />} />
      </Routes>
    </TeamEntryManagementContextView>
  );
};

const TeamEntryManagement = () => (
  <MeetContextProvider>
    <MeetFiltersContextProvider>
      <OmeMeetContextProvider>
        <OmeMeetEntryContextProvider>
          <OmeMeetOrgUnitEntryContextProvider>
            <OmeMeetOrgUnitEntryInfoContextProvider>
              <OmeMeetTeamEntryContextProvider>
                <OmeMeetTeamEntryFiltersContextProvider>
                  <PersonOrgRoleContextProvider>
                    <SearchMeetContextProvider>
                      <MeetCompetitionSummaryContextProvider>
                        <OmeMeetAthleteEntryContextProvider>
                          <OmeMeetAthleteEntryFiltersContextProvider>
                            <OmeMeetOrgUnitAthleteEntryIndividualRosterEntryContextProvider>
                              <MeetStaffContextProvider>
                                <OmeMeetEntryInfoContextProvider>
                                  <OrgUnitOmeMeetEntryContextProvider>
                                    <TeamEntryManagementRoutes />
                                  </OrgUnitOmeMeetEntryContextProvider>
                                </OmeMeetEntryInfoContextProvider>
                              </MeetStaffContextProvider>
                            </OmeMeetOrgUnitAthleteEntryIndividualRosterEntryContextProvider>
                          </OmeMeetAthleteEntryFiltersContextProvider>
                        </OmeMeetAthleteEntryContextProvider>
                      </MeetCompetitionSummaryContextProvider>
                    </SearchMeetContextProvider>
                  </PersonOrgRoleContextProvider>
                </OmeMeetTeamEntryFiltersContextProvider>
              </OmeMeetTeamEntryContextProvider>
            </OmeMeetOrgUnitEntryInfoContextProvider>
          </OmeMeetOrgUnitEntryContextProvider>
        </OmeMeetEntryContextProvider>
      </OmeMeetContextProvider>
    </MeetFiltersContextProvider>
  </MeetContextProvider>
);

export default TeamEntryManagement;